import { useEffect, useState } from 'react';

import { fetch_payout_deleted_summary } from '../api';
import { deleted_summary_failed, deleted_summary_view } from './deleted_alert';

/* how many deleted accounts have money due, for the page banner and the Bank payouts badge. */
export const useDeletedSummary = (rev = 0, enabled = true) => {
  const [view, setView] = useState({ count: 0, complete: true });
  useEffect(() => {
    if (!enabled) {
      setView({ count: 0, complete: true });
      return undefined;
    }
    let cancelled = false;
    fetch_payout_deleted_summary()
      .then((data) => {
        if (!cancelled) setView(deleted_summary_view(data));
      })
      .catch((e) => {
        if (cancelled) return;
        const next = deleted_summary_failed(e);
        if (next.unknown)
          console.error('deleted-accounts summary read failed', e?.response?.status || e?.message);
        setView(next);
      });
    return () => {
      cancelled = true;
    };
  }, [rev, enabled]);
  return view;
};

export default useDeletedSummary;
